<template>
  <MCarousel :data-widget-title="content.optionalTitle?.text">
    <template #header>
      <div class="container">
        <SliceTitle
          v-if="content.optionalTitle"
          class="title lg:text-center"
          :value="content.optionalTitle"
        />
        <a
          v-if="content.optionalLink && !hasInvalidPlaceholderValue(content.optionalLink.label)"
          class="pt-4 font-semibold underline text-gray-500 block text-center"
          :href="content.optionalLink.link ?? undefined"
        >
          {{ content.optionalLink.label }}
        </a>
      </div>
    </template>
    <EntityCard
      v-for="(item, i) in items"
      :key="i"
      :entity="item"
      :is-featured="isFeatured(item, i)"
    />
  </MCarousel>
</template>

<script lang="ts" setup>
import EntityCard from './entity-card.vue'
import MCarousel from './m-carousel.vue'
import type {
  GQLEntitiesScoresSlice,
  GQLEntityScoresProvider as Provider,
  GQLEntityScoresCountry as Country,
} from './generated/entities-scores'

const ENTITIES_LIMIT = 12
const props = defineProps<{ content: GQLEntitiesScoresSlice }>()

function byScore(a: Provider | Country, b: Provider | Country) {
  return (b.score?.value ?? 0) - (a.score?.value ?? 0)
}

function isFeatured(entity: GQLEntitiesScoresSlice['entities'][number], index: number) {
  if (props.content.autoMode) {
    return index === 0
  }
  if (!props.content.featuredEntity) {
    return index === 0 && 'slug' in entity
  }
  if ('iso' in entity && 'iso' in props.content.featuredEntity) {
    return entity.iso === props.content.featuredEntity.iso
  }

  if ('slug' in entity && 'slug' in props.content.featuredEntity) {
    return entity.slug === props.content.featuredEntity.slug
  }

  return false
}

const items = computed((): Array<Country | Provider> => {
  if (!props.content.entities.length) {
    return []
  }

  const entities = props.content.entities
    .filter(isNotNull)
    .filter((entity) => entity.score?.value)
    .filter((entity) => {
      if (!props.content.featuredEntity) {
        return true
      }
      if ('iso' in props.content.featuredEntity && 'iso' in entity) {
        return entity.iso !== props.content.featuredEntity.iso
      }
      if ('slug' in entity && 'slug' in props.content.featuredEntity) {
        return entity.slug !== props.content.featuredEntity.slug
      }
      return true
    })
    .sort(byScore)
    .slice(0, props.content.numberTopEntities || ENTITIES_LIMIT)

  if (props.content.featuredEntity) {
    entities.unshift(props.content.featuredEntity)
  }
  return entities
})
</script>
